import React from 'react';
import styles from './css/index.module.scss';
import useTranslations from '../../hooks/useTranslations';
import { DICTIONARY } from '../../translations/dictionary';
import LogoIcon from '../../assets/images/LogoText.svg';

function ServerError() {
  const { t } = useTranslations();

  return (
    <div className={styles.wrapper}>
      <img src={LogoIcon} alt="Logo" className={styles.logo} />
      <p className={styles.title}>{t(DICTIONARY.serverErrorTitle)}</p>
      <p className={styles.text}>{t(DICTIONARY.serverErrorText)}</p>
    </div>
  );
}

export default ServerError;
